
export default {

  UPDATE_USER_INFO (state, payload) {

      for (const property of Object.keys(payload)) {
          if (payload[property] !== null) {
            state.user[property] = payload[property]

          }

      }
  },

}
